export const AI_MESSAGE_ATTRIBUTE = 'AI_MESSAGE'
